import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfCmsModal } from '@df/ui/modal/df-cms-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ModalLayoutRightComponent, NModalLayoutRight } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
export interface IV12RetailFinanceModalBlockDataContent {
    description?: string;
    title?: string;
    finance_tile?: string;
    elements?: IV12RetailFinanceModalElements[];
    finance_footer?: string;
}
export interface IV12RetailFinanceModalElements {
    title: string;
    value: string;
}
export const V12_RETAIL_FINANCE_FROM_MODAL_ID = 'v12RetailFinanceFromModal';
@DfCmsModal({
    id: V12_RETAIL_FINANCE_FROM_MODAL_ID,
    name: 'V12 Retail Finance From Modal',
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName),
        modalClass: 'bg-col-w p-l-0 p-r-0 p-t-0'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@ICmsComponent<V12RetailFinanceModalComponent>({
    id: 'v12_retail_finance_from',
    block: {
        url: 'v12_retail_finance_from'
    },
    onDemandOnly: true,
    name: 'V12 Retail Finance From Modal',
    description: 'V12 Retail Finance From Modal Content',
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Main title'
        },
        <NICmsContentField.IField>{
            key: 'description',
            type: NICmsContentField.EFieldType.text,
            title: 'Description'
        },
        <NICmsContentField.IField>{
            key: 'finance_tile',
            type: NICmsContentField.EFieldType.text,
            title: 'Representative finance example title'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'elements',
            title: 'Representative finance example elements',
            itemName: 'Item',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'value',
                    title: 'Value',
                    required: true
                }
            ]
        },
        <NICmsContentField.IField>{
            key: 'finance_footer',
            type: NICmsContentField.EFieldType.text,
            title: 'Finance footer'
        }
    ]
})
@Component({
    selector: 'v12-retail-finance-from-modal',
    templateUrl: './v12-retail-finance-from-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalLayoutRightComponent, CommonModule, SizeClassDirective, ICmsClientModule]
})
export class V12RetailFinanceModalComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IV12RetailFinanceModalBlockDataContent;
}
